/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_AffiliatesInputs */

const en_directory_footer_link_affiliates = /** @type {(inputs: Directory_Footer_Link_AffiliatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliates`)
};

const zh_directory_footer_link_affiliates = /** @type {(inputs: Directory_Footer_Link_AffiliatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联盟计划`)
};

/**
* | output |
* | --- |
* | "Affiliates" |
*
* @param {Directory_Footer_Link_AffiliatesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_affiliates = /** @type {((inputs?: Directory_Footer_Link_AffiliatesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_AffiliatesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_affiliates(inputs)
	return zh_directory_footer_link_affiliates(inputs)
});
export { directory_footer_link_affiliates as "directory.footer.link_affiliates" }